export default __webpack_public_path__ + "static/media/duke_thumbnail.50aa254f.png";